import { useState } from 'react';
import { createJobCost } from '../api/jobCosts';
import type { CreateJobCostRequest, JobCost } from '../types/jobCost';

/**
 * Hook for creating a new job cost
 */
export function useCreateJobCost() {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = async (
    jobId: number,
    data: CreateJobCostRequest
  ): Promise<JobCost | null> => {
    setIsCreating(true);
    setError(null);
    try {
      const cost = await createJobCost(jobId, data);
      return cost;
    } catch (err) {
      const error = err as { response?: { data?: { message?: string } } };
      setError(error.response?.data?.message || 'Failed to create job cost');
      return null;
    } finally {
      setIsCreating(false);
    }
  };

  return {
    create,
    isCreating,
    error,
  };
}
